// ESM-Huelle fuer lib/scripts/components/CMP_CComponent.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.

//******************************************************************************
// CDataListener
//******************************************************************************
// Description:
//      All components inherit from this class. Provides all basic functions for
//      creating and transmitting a component to the client.
//******************************************************************************

// *** Constructor ***/
function CComponent() {
	this.name = null;
	this.id = null;
        this.addclass="";
	this.builder = null;
	this.children = null;
	this.childrenCount = 0;
	this.collector = null;
	this.transmitted = false;
	this.prepared = false;
	//this.gfx = null;
	this.htmlType = null;
	this.components = null;
	this.locked = false;
	this.mainLocked = false;
	this.name = "CComponent";
	this.lastVisibility = null;
	this.cacheMe = false;
	this.cacheId = "CComponent";
	this.enabledLock = false;
	this.properties = {
		value : null,
		isMoveable : false,
		disableType : "DEFAULT",
		styles : {},
		events : {}
	}
}
// ***

// *** Class methods ***
//------------------------------------------------------------------------------
// Description:
//      Run this method from an inherited class to initialize the class.
//
// id - The component ID.
//------------------------------------------------------------------------------
CComponent.prototype.construct = function (id, addclass, session) {
	this.id = id;
        this.addclass = addclass;
	this.children = new Array();
	this.components = new Object();
	this.builder = new CComponentBuilder(this, this.id, addclass);
	//this.gfx = new CGFX(this);
}

/*
CComponent.prototype.addOnclickEvent = function(el,parameters, me, clickfunc) {
   l = el.length;
   for (i = 0; i < l; i++) {
        el[i].parentElement.addEventListener("click", function(e) {
                if (e.toElement.tagName == "DIV"){
                         clickfunc(e.toElement,parameters);
                } else {
                        clickfunc(e.toElement.parentElement,parameters);
                }
        },false);
    }
}
*/

//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Adds a child component to this component.
//------------------------------------------------------------------------------
CComponent.prototype.addChild = function (type, addclass) {
	var obj;

	if (typeof type == "function")
		obj = new type(this.id + ":" + this.childrenCount, addclass);
	else if (typeof type == "string") {
		// Klassenname aus XML-Layout (z.B. <component>CPushPanel</component>):
		// direkter Lookup statt eval - alle Komponentenklassen sind (noch)
		// Globals; nach ESM-Konvertierung publiziert die legacy-bridge sie
		// weiter auf window. Unbekannter Name wirft wie frueher (eval warf
		// eine ReferenceError).
		var ctor = window[type];
		if (typeof ctor != "function")
			throw new ReferenceError(type + " is not defined (CComponent.addChild aus XML-Layout)");
		obj = new ctor(this.id + ":" + this.childrenCount, addclass);
	} else
		return null;

	this.children[this.childrenCount] = obj;
	this.childrenCount++;

	return obj;
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Adds a created component to this component.
//------------------------------------------------------------------------------
CComponent.prototype.addCreatedChild = function (component) {
	this.children[this.childrenCount] = component;
	component.id = this.id + ":" + this.childrenCount;
	component.builder.id = component.id;

	this.childrenCount++;

	return component.id;
}
//------------------------------------------------------------------------------

CComponent.prototype.createChildrenFromXML = function (xml, path) {
	if (typeof path == "undefined")
		path = "";

	var object = xml.convert2Object(path);
	this.createChildrenFromObject(object, this);
}

CComponent.prototype.createChildrenFromObject = function (object, parent) {
	if (typeof object["children"] == "undefined")
		return;

	for (window.i in object["children"]) {
		if (typeof object["children"][i]["component"] != "undefined") {
			parent.components[i] = parent.addChild(object["children"][i]["component"]);
			if (typeof object["children"][i]["properties"] != "undefined")
				parent.components[i].properties = combine(parent.components[i].properties,
						object["children"][i]["properties"]);
			this.createChildrenFromObject(object["children"][i], parent.components[i]);
		}
	}
}

CComponent.prototype.setStyleFromXML = function (xml) {
	var file = "etc/defaults/LYT_" + this.name + ".xml";

	// Thunk statt eval-Command-String (toCache fuehrt ihn nur bei Cache-Miss aus).
	var object = POS.cache.toCache(this.name + "XMLOBJECT", function () {
		return (new CXmlHandler(file)).convert2Object("");
	});

	this.properties = combine(this.properties, object);
}

//------------------------------------------------------------------------------
// Description:
//      Removes all children of the component.
//------------------------------------------------------------------------------
CComponent.prototype.clearChildren = function () {
	this.children = new Array();
	this.childrenCount = 0;
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Draws the component and alls its children and transmits it to the
//      client.
//------------------------------------------------------------------------------
CComponent.prototype.draw = function (transmit, fromCache) {
	var CComponentClass = this;
	var xml;
	var def = $.Deferred();
	var defprep2 = $.Deferred();
	if (typeof fromCache == "undefined")
		fromCache = false;

	if (this.cacheMe == true)
		POS.cache.datacacheFromDisc(this.cacheId);

	if (!this.prepared) {

		var defprep = this.prepare();
		defprep2 = 0;

	} else {
		defprep2.resolve();
		defprep = 0;
	}
	$.when(defprep, defprep2).done(function () {

		if (POS.cache.checkDataCache(CComponentClass.cacheId) == false && fromCache == false) {
			if (typeof transmit == "undefined")
				transmit = true;

			if (CComponentClass.collector != null)
				CComponentClass.builder.collector = CComponentClass.collector;

			CComponentClass.create();
		} else if (fromCache == false) {
			xml = POS.cache.dataFromCache(CComponentClass.cacheId);
			xml = xml.replace(/\"[0-9]:/g, "\"" + POS.sessions.currentSession + ":");

			var element = document.createElement("span");
			element.innerHTML = xml;

			CComponentClass.builder.doAddElement(element.firstChild);

			fromCache = true;
			transmit = false;

			CComponentClass.transmitted = true
		} else if (fromCache == true) {
			CComponentClass.transmitted = true
		}

		$.when(CComponentClass.drawChildren(transmit, fromCache)).done(function () {
			if (CComponentClass.cacheMe == true && POS.cache.checkDataCache(CComponentClass.cacheId) == false) {
				var serializer = new XMLSerializer();
				xml = serializer.serializeToString(CComponentClass.builder.mainElement);

				POS.cache.dataToCache(CComponentClass.cacheId, xml);
				POS.cache.datacacheToDisc(CComponentClass.cacheId);
			}

			if (transmit == true) {
				CComponentClass.transmit();
//				CComponentClass.addEvents(CComponentClass.builder.mainElement, CComponentClass);
			}
			def.resolve();
		});
	});
	return def.promise();
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Subfunction to the draw() function to draw all children of the
//      component.
//------------------------------------------------------------------------------
CComponent.prototype.drawChildren = function (transmit, fromCache) {
	/*for (var i = 0; i < this.childrenCount; i++)
	this.children[i].draw(transmit, fromCache);*/
	var def = $.Deferred();
	var CComponentClass = this;
	var iterator = function it(i) {
		if (i < CComponentClass.childrenCount) {
			$.when(CComponentClass.children[i].draw(transmit, fromCache)).then(function () {
				iterator(i + 1);
				return;
			});
		} else {
			def.resolve();
			return;
		}
	}
	iterator(0);
	return def.promise();
}
//------------------------------------------------------------------------------

CComponent.prototype.setEnabled = function (bool, persistant) {
	if (this.enabledLock == true)
		return;

	if (typeof persistant != "undefined" && persistant == true)
		this.enabledLock = true;

	if (bool) {
		//if (this.properties && this.properties.styles)
		//	this.gfx.reset();
	    var  id =  document.getElementById(this.id);
		if (id && id.classList){
			id.classList.remove("disabled");
		} else {
			
		}
		this.locked = false;
		this.mainLocked = false;
	} else {
	//	if (typeof this.properties != "undefined" &&
	//		typeof this.properties.styles != "undefined") {
	//		this.gfx.disableMe();
	//	}
		this.locked = true;
		this.mainLocked = true;
		id= document.getElementById(this.id);
		if (id && id.classList){
			id.classList.add("disabled");
		} else {
			if (this.addclass){
			 this.addclass=this.addclass+" disabled";}
			else {
			 this.addclass="disabled";
			}
		}
	}

	if (this.prepared)
		this.reStyle();

	for (var i = 0; i < this.childrenCount; i++)
		this.children[i].lock(!bool);
}

CComponent.prototype.lock = function (bool) {
	if (this.mainLocked)
		return;

	this.locked = bool;

	for (var i = 0; i < this.childrenCount; i++)
		this.children[i].lock(bool);
}

//------------------------------------------------------------------------------
// Description:
//      Usually overloaded by an inherited class. If not it just sets prepared
//      to true.
//------------------------------------------------------------------------------
CComponent.prototype.prepare = function () {
	this.prepared = true;
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Usually overloaded by an inherited class. Standard function to create
//      the component.
//------------------------------------------------------------------------------
CComponent.prototype.create = function () {
	this.builder.addElement(this.htmlType, this.properties);
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Redraws the component and all its children.
//------------------------------------------------------------------------------
CComponent.prototype.reDraw = function () {
	var saveCollector = this.collector;
	var disable = false;
	var CComponentClass = this;
	var defret = $.Deferred();

	this.collector = true;
	this.prepared = true;
	$.when(this.draw(false)).done(function () {
		CComponentClass.removeMe();
		CComponentClass.transmit();
		CComponentClass.setTransmitted(true);
		CComponentClass.collector = saveCollector;
		defret.resolve();
	});
	return defret.promise();
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Makes the component moveable.
//------------------------------------------------------------------------------
CComponent.prototype.setAsMover = function () {
	this.properties.isMoveable = true;

	if (this.transmitted == false)
		return;

	var element = document.getElementById(this.id);
	POS.mover.set(element, this.id);
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Resends the style of the component to the client.
//------------------------------------------------------------------------------
CComponent.prototype.reStyle = function () {
	if (this.transmitted == false)
		return;

	if (typeof this.properties != "undefined" &&
		typeof this.properties.styles != "undefined");
	else
		return;

	var element = document.getElementById(this.id);
	//if (!element) element = this.getElementById(this.id);

	// ESM-Welle 5b: gleicher Waechter wie in componentbuilder.js - ist
	// properties.styles ein String, liefert "for in" dessen Indizes und
	// element.style["0"] = ... wirft im Strict-Mode, statt wie bisher
	// still verworfen zu werden. Wertgleich, weil die Schleife fuer jedes
	// Primitive noch nie eine Wirkung hatte.
	if (element && typeof this.properties.styles == "object" && this.properties.styles != null) {
		for (var u in this.properties.styles)
			element.style[u] = this.properties.styles[u];
	}
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Refreshes the attributes of the component in the DOM.
//------------------------------------------------------------------------------
CComponent.prototype.reAttribute = function () {
	var element = document.getElementById(this.id);
	try {
		for (var i in this.properties.attributes) {
			//if (i && this.properties.attributes[i]) {
			element.setAttribute(i, this.properties.attributes[i]);
		}
	} catch (e) {
		//var e = new Error('dummy');
		var stack = e.stack.replace(/^[^\(]+?[\n$]/gm, '')
			.replace(/^\s+at\s+/gm, '')
			.replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@')
			.split('\n');
		log.add(1, "Error Component reAttribute", 'setAttribute is null, element: ' + element + ",Stack: " + stack, null);
	}

}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Refreshes the value of the component in the DOM.
//------------------------------------------------------------------------------
CComponent.prototype.reValue = function () {
	if (this.transmitted == false)
		return;

	var element = document.getElementById(this.id);
	element.innerHTML = this.properties.value;
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Removes the component and all its children.
//------------------------------------------------------------------------------
CComponent.prototype.removeMe = function () {
	if (this.transmitted == false)
		return;

	var element = document.getElementById(this.id);
	element.parentNode.removeChild(element);

	this.setTransmitted(false);
}
//------------------------------------------------------------------------------

CComponent.prototype.majorHide = function () {
	this.properties.styles.zIndex = "0";
	this.reStyle();
}

CComponent.prototype.majorShow = function () {
	this.properties.styles.zIndex = "2";
	this.reStyle();
}

CComponent.prototype.setTransmitted = function (bool) {
	this.transmitted = bool;

	for (var i = 0; i < this.childrenCount; i++) {
		this.children[i].transmitted = bool;
		this.children[i].setTransmitted(bool);
	}
}

//------------------------------------------------------------------------------
// Description:
//      Sets the focus to the component in the DOM.
//------------------------------------------------------------------------------
CComponent.prototype.setFocus = function () {
	POS.events.unlock();
	//document.activeElement.blur();
	//POS.lostFocus(POS.focusedComponent.id);
	var element = document.getElementById(this.id);
	element.focus();
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Scrolls the component up and down by amount.
//
// amount - Scroll component by given amount.
//------------------------------------------------------------------------------
CComponent.prototype.scroll = function (amount) {
	var element = document.getElementById(this.id);
	var h = element.scrollHeight;
	var s = element.scrollTop;

	s += parseInt(amount);

	if (s > h)
		s = h;
	if (s < 0)
		s = 0;

	element.scrollTop = s;
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Scrolls the component to an absolute position.
//
// amount - Scroll component to position.
//------------------------------------------------------------------------------
CComponent.prototype.scrollAbs = function (amount) {
	var element = document.getElementById(this.id);
	var h = element.scrollHeight;

	var s = amount;

	if (s > h)
		s = h;
	if (s < 0)
		s = 0;

	element.scrollTop = s;
}


CComponent.prototype.addEvents = function () {
	
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Transmits the component to the client.
//------------------------------------------------------------------------------
CComponent.prototype.transmit = function () {

	if (this.transmitted == false) {
		this.builder.build()
		this.transmitted = true;
		this.setMovers();
//this.addEvents();
	}

}
//------------------------------------------------------------------------------

CComponent.prototype.setMovers = function () {
	if (typeof this.properties.isMoveable != "undefined" &&
		this.properties.isMoveable == true) {
		this.setAsMover();
	}

	for (var i = 0; i < this.childrenCount; i++)
		this.children[i].setMovers();
}

//------------------------------------------------------------------------------
// Description:
//      Receives an event trigger from the client and calls the proper
//      functions. First the event function owned by the component is called,
//      second the foreign function is called if set in the properties.
//------------------------------------------------------------------------------
CComponent.prototype.eventTrigger = function (event, parameters, eventObj) {
	// event ist ein Handlername wie "onMousedown" - direkter Property-Aufruf
	// statt eval (identische Semantik inkl. TypeError bei fehlendem Handler).
	this[event](event, parameters, eventObj);

	if (typeof this.properties != "undefined" && typeof this.properties.events != "undefined"
		 && typeof this.properties.events[event] == "function") {
		if (this.locked == true) {
			POS.hourGlass.show("Funktion momentan nicht verf&uuml;gbar!");
			POS.timeout.register("CComponentLock", POS.hourGlass.hide, null, 4, 1);
			POS.events.unlock();
			return;
		}

		POS.timeout.setTimeout("'" + this.id + "', " + this.name + ", " + event,
			this.properties.events[event], 1, this, parameters);
	} else {
		POS.events.unlock();
	}
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Component owned 'onFocus' event function. If the component is focused
//      the session focus object is set.
//------------------------------------------------------------------------------
CComponent.prototype.onFocus = function (event, parameters, eventObj) {
	POS.gotFocus(this.id);
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Component owned 'onBlur' event function. If the component lost its focus
//      the session focus object is cleared.
//------------------------------------------------------------------------------
CComponent.prototype.onBlur = function (event, parameters, eventObj) {
	POS.lostFocus(this.id);
}
//------------------------------------------------------------------------------

//------------------------------------------------------------------------------
// Description:
//      Component owned event function collection. Those purpose is to be
//      overloaded.
//------------------------------------------------------------------------------
CComponent.prototype.onClick = function (event, parameters, eventObj) {}
CComponent.prototype.onAbort = function (event, parameters, eventObj) {}
CComponent.prototype.onChange = function (event, parameters, eventObj) {}
CComponent.prototype.onDblClick = function (event, parameters, eventObj) {}
CComponent.prototype.onError = function (event, parameters, eventObj) {}
CComponent.prototype.onKeydown = function (event, parameters, eventObj) {}
CComponent.prototype.onKeypress = function (event, parameters, eventObj) {}
CComponent.prototype.onKeyup = function (event, parameters, eventObj) {}
CComponent.prototype.onLoad = function (event, parameters, eventObj) {}
CComponent.prototype.onMousedown = function (event, parameters, eventObj) {}
CComponent.prototype.onMousemove = function (event, parameters, eventObj) {}
CComponent.prototype.onMouseout = function (event, parameters, eventObj) {}
CComponent.prototype.onMouseover = function (event, parameters, eventObj) {}
CComponent.prototype.onMouseup = function (event, parameters, eventObj) {}
CComponent.prototype.onReset = function (event, parameters, eventObj) {}
CComponent.prototype.onResize = function (event, parameters, eventObj) {}
CComponent.prototype.onSelect = function (event, parameters, eventObj) {}
CComponent.prototype.onSubmit = function (event, parameters, eventObj) {}
CComponent.prototype.onUnload = function (event, parameters, eventObj) {}
//------------------------------------------------------------------------------
// ***

//******************************************************************************

export { CComponent };
